import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import VueGtag from "vue-gtag";
import GAuth from 'vue-google-oauth2'
import "./plugins/filters"

import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';

const socket = io("https://sprint-app.com:3000/")

Vue.use(VueSocketIOExt, socket);

import Lightbox from 'vue-easy-lightbox'
Vue.use(Lightbox)

import { gauthOption } from './plugins/googleConfig'

// Vue.prototype.$http = Axios;

// import layuots
import Default from "./layouts/Default.vue";
import Dashboard from "./layouts/Dashboard.vue";

// use layouts
Vue.component("default-layout", Default);
Vue.component("dashboard-layout", Dashboard);

Vue.config.productionTip = false
// Vue.use(require('vue-chartist'))

// const isProd = process.env.NODE_ENV === 'production'

Vue.filter('date', function (val) {
  if (!val) return "";
  val = val.toString();
  return val.substr(0, 10);
})

Vue.use(VueGtag, {
  config: {
    id: "UA-150084031-1",
    appName: 'Sportopia',
    params: {
      send_page_view: false
    },
    pageTrackerScreenviewEnabled: true
  },
}, router);

Vue.use(GAuth, gauthOption)


// auth routing guard
import authGuard from './auth-guard'
router.beforeEach(authGuard);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
